import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NiTextFieldComponent } from './ni-text-field/ni-text-field.component';
import { NiButtonComponent } from './ni-button/ni-button.component';
import { NiAutocompleteComponent } from './ni-autocomplete/ni-autocomplete.component';
import { NiDatePickerComponent } from './ni-date-picker/ni-date-picker.component';
import { NiOptionComponent } from './ni-option/ni-option.component';
import { NiIconComponent } from './ni-icon/ni-icon.component';
import { NiAlertComponent } from './ni-alert/ni-alert.component';
import { NiTableComponent } from './ni-table/ni-table.component';
import { NiTableCellDirective } from './ni-table/ni-table-cell.directive';

import { NiAutocompleteComponent as NiFormAutocompleteComponent } from './form/ni-autocomplete/ni-autocomplete.component';
import { NiButtonComponent as NiFormButtonComponent } from './form/ni-button/ni-button.component';
import { NiCheckboxComponent as NiFormCheckboxComponent } from './form/ni-checkbox/ni-checkbox.component';
import { NiChipComponent as NiFormChipComponent } from './form/ni-chip/ni-chip.component';
import { NiDatePickerComponent as NiFormDatePickerComponent } from './form/ni-date-picker/ni-date-picker.component';
import { NiFileUploadComponent as NiFormFileUploadComponent } from './form/ni-file-upload/ni-file-upload.component';
import { NiModalComponent as NiFormModalComponent } from './form/ni-modal/ni-modal.component';
import { NiMoremenuComponent as NiFormMoremenuComponent } from './form/ni-moremenu/ni-moremenu.component';
import { NiIconComponent as NiFormIconComponent } from './form/ni-icon/ni-icon.component';
import { NiOptionComponent as NiFormOptionComponent } from './form/ni-option/ni-option.component';
import { NiOtpComponent as NiFormOtpComponent } from './form/ni-otp/ni-otp.component';
import { NiProgressStepperComponent as NiFormProgressStepperComponent } from './form/ni-progress-stepper/ni-progress-stepper.component';
import { NiRadioComponent as NiFormRadioComponent } from './form/ni-radio/ni-radio.component';
import { NiSelectComponent as NiFormSelectComponent } from './form/ni-select/ni-select.component';
import { NiTextFieldComponent as NiFormTextFieldComponent } from './form/ni-text-field/ni-text-field.component';
import { NiTextareaComponent as NiFormTextareaComponent } from './form/ni-textarea/ni-textarea.component';
import { NiToasterComponent as NiFormToasterComponent } from './form/ni-toaster/ni-toaster.component';
import { NiToggleComponent as NiFormToggleComponent } from './form/ni-toggle/ni-toggle.component';

@NgModule({
  declarations: [
    // Only non-standalone components should be declared here
    // NiButtonDirective
    ],
  imports: [
    CommonModule,
    NiTextFieldComponent,
    NiButtonComponent,
    NiAutocompleteComponent,
    NiDatePickerComponent,
    NiOptionComponent,
    NiIconComponent,
    NiAlertComponent,
    NiTableComponent,
    NiTableCellDirective,
    NiFormAutocompleteComponent,
    NiFormButtonComponent,
    NiFormCheckboxComponent,
    NiFormChipComponent,
    NiFormDatePickerComponent,
    NiFormFileUploadComponent,
    NiFormIconComponent,
    NiFormModalComponent,
    NiFormMoremenuComponent,
    NiFormOptionComponent,
    NiFormOtpComponent,
    NiFormProgressStepperComponent,
    NiFormRadioComponent,
    NiFormSelectComponent,
    NiFormTextFieldComponent,
    NiFormTextareaComponent,
    NiFormToasterComponent,
    NiFormToggleComponent,
  ],
  exports: [
    NiTextFieldComponent,
    NiButtonComponent,
    // NiButtonDirective,
    NiAutocompleteComponent,
    NiDatePickerComponent,
    NiOptionComponent,
    NiIconComponent,
    NiAlertComponent,
    NiTableComponent,
    NiTableCellDirective,
    NiFormAutocompleteComponent,
    NiFormButtonComponent,
    NiFormCheckboxComponent,
    NiFormChipComponent,
    NiFormDatePickerComponent,
    NiFormFileUploadComponent,
    NiFormIconComponent,
    NiFormModalComponent,
    NiFormMoremenuComponent,
    NiFormOptionComponent,
    NiFormOtpComponent,
    NiFormProgressStepperComponent,
    NiFormRadioComponent,
    NiFormSelectComponent,
    NiFormTextFieldComponent,
    NiFormTextareaComponent,
    NiFormToasterComponent,
    NiFormToggleComponent,
  ]
})
export class LibraryModule { }